

<script>
  import { Bar } from 'vue-chartjs'

  export default {
    name: "BarChart",
    extends: Bar,
    data () {
      return {
        chartData: {
          labels: [],
          datasets: [{
              labels: [],
              data: [],
              backgroundColor: [],
              borderColor: [],
            }]
        },
        options: {
          legend: {
            display: false
          },          
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [{
                ticks: {
                    userCallback: function(label) {
                    if( label.length>16 )
                    {
                      return label.substring(0,13)+'...'
                    }
                      return label
              
                    },
                    maxRotation: 60,
                    minRotation: 60
                }
            }]
          }
        }
      }
    },
    methods: {
        buildChart: function(raw_data) {
            this.chartData.labels = []
            this.chartData.datasets[0].data=[]
            this.chartData.datasets[0].backgroundColor=[];
            this.chartData.datasets[0].borderColor=[];
            for(let i in raw_data){
                this.chartData.labels.push(raw_data[i][0])
                this.chartData.datasets[0].data.push(raw_data[i][1])
                this.chartData.datasets[0].backgroundColor.push(this.$store.getters.disciplines[raw_data[i][0]])
                this.chartData.datasets[0].borderColor.push(this.$store.getters.disciplines[raw_data[i][0]])
            }

            this.renderChart(this.chartData, this.options)
        }
    },
    mounted() {
        console.log("arribo al Barchart")
        this.$root.$on('BarChartCluster', () => {
            this.buildChart(this.$store.getters.dades_bar_chart_cluster);
            this.$root.$off('BarChartZona');
        });
        this.$root.$on('BarChartZona', () => {
            this.buildChart(this.$store.getters.dades_bar_chart_zona);
            this.$root.$off('BarChartCluster');
        });
    },
    beforeDestroy() {
        console.log("mato al Barchart")
        this.$root.$off('BarChartCluster');
        this.$root.$off('BarChartZona');
    }
  }
</script>